'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var useInputFile = require('./useInputFile.js');
var Files = require('./Files.js');
var TypeAndSizeLabel = require('./TypeAndSizeLabel.js');
var context = require('./context.js');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["accept", "maxSizeLabel", "label"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * File upload component
 *
 * It brings the following improvements over a default file input:
 *
 *   1. Automatically shows the accepted file types above the input
 *   2. Automatically shows the selected file name(s)
 *   3. Prevents clearing the input when pressing ESC on an empty
 *      file input dialog.
 *   4. Automatically handles hiding the upload button when ...
 *      * `isDisabled` is set
 *      * it is a single-file input (`multiple` is not set) and one
 *        file was uploaded
 *   5. It shows a clear / delete button to clear file(s)
 *   6. It supports custom file types. By default, it supports {@link AssetLike}. This is intended so asset objects
 *      can be passed as default values.
 *
 *
 * **IMPORTANT**
 *
 * In React, an `<input type="file" />` is always an uncontrolled component because
 * its value can only be set by a user, and not programmatically. This means
 * it can never be controlled.
 */
// eslint-disable-next-line react/function-component-definition -- Needs to be a function for the generic type.
function InputFile(props, ref) {
  var accept = props.accept,
    maxSizeLabel = props.maxSizeLabel,
    _props$label = props.label,
    label = _props$label === void 0 ? 'Datei hinzufügen' : _props$label,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var context$1 = useInputFile.useInputFile(_objectSpread(_objectSpread({}, rest), {}, {
    accept: accept
  }));
  var getHtmlProps = context$1.getHtmlProps,
    getInputProps = context$1.getInputProps,
    getButtonProps = context$1.getButtonProps;
  return /*#__PURE__*/React__default["default"].createElement(context.InputFileProvider, {
    value: context$1
  }, /*#__PURE__*/React__default["default"].createElement(react.Box, getHtmlProps(), /*#__PURE__*/React__default["default"].createElement(react.Box, {
    as: "label"
  }, /*#__PURE__*/React__default["default"].createElement(TypeAndSizeLabel.TypeAndSizeLabel, {
    accept: accept,
    maxSizeLabel: maxSizeLabel
  }), /*#__PURE__*/React__default["default"].createElement(react.VisuallyHidden, null, /*#__PURE__*/React__default["default"].createElement("input", getInputProps({}, ref))), /*#__PURE__*/React__default["default"].createElement(react.Button, getButtonProps(), label)), /*#__PURE__*/React__default["default"].createElement(Files.Files, null)));
}
var _InputFile = react.forwardRef(InputFile);

// https://github.com/mobxjs/mobx-react/issues/352#issuecomment-341861198
_InputFile.displayName = 'InputFile';
exports.InputFile = _InputFile;